import { render, staticRenderFns } from "./ExamPlan.vue?vue&type=template&id=0a4bafe4&scoped=true"
import script from "./ExamPlan.vue?vue&type=script&lang=js"
export * from "./ExamPlan.vue?vue&type=script&lang=js"
import style0 from "./ExamPlan.vue?vue&type=style&index=0&id=0a4bafe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bafe4",
  null
  
)

export default component.exports